import {DEFAULT_CURRENCY} from '@/constants/currencies'

export default {
    version: '1.0.1',

    // TODO move all of these configs to CI/CD variables
    auth: {
        user: {
            storageKey: 'auth',
            userInfoKey: 'userInfo'
        },
        idleTimeout: 10
    },
    currency: DEFAULT_CURRENCY
}
